import SpecialtyService from '../services/specialty.service';

export const specialty = {
  namespaced: true,
  state: {
    specialtyList: [],
    specialityTheme: []
  },
  actions: {
    async getSpecialtyList({ commit }) {
      const resp = await SpecialtyService.getSpecialtyList();
      if (resp.status === 200) {
        commit('SET_SPECIALTY_LIST', resp.data);
      }
      return resp.status;
    },
    async getSpecialtyTheme({ commit }) {
      const resp = await SpecialtyService.getSpecialtyTheme();
      if (resp.status === 200) {
        for  (var i=0; i<resp.data.length; i++) {
          resp.data[i].allSelected = false
        }
        commit('SET_SPECIALITY_THEME', resp.data)
      }
      return resp.status;
    },
    async createSpecialty(_, newSpecialty) {
      const resp = await SpecialtyService.createSpecialty(newSpecialty);
      return resp.status;
    },
    async editSpecialty(_, currentSpecialty) {
      const resp = await SpecialtyService.editSpecialty(currentSpecialty);
      return resp.status;
    },
    async deleteSpecialty(_, specialtyId) {
      const resp = await SpecialtyService.deleteSpecialty(specialtyId);
      return resp.status;
    },
  },
  mutations: {
    SET_SPECIALTY_LIST(state, specialtyList) {
      state.specialtyList = specialtyList;
    },
    SET_SPECIALITY_THEME(state, specialityTheme){
      state.specialityTheme = specialityTheme;
    }
  },
};
